import {Tabs, TabsColorScheme, TabsContainer} from "../../shared/TabsContainer";
import {DatasetOutlined, Groups3Outlined, HomeOutlined} from "@mui/icons-material";
import {DashboardFragment} from "./dashboard/DashboardFragment";
import React from "react";
import {PathComponent} from "../../index";
import {AppTabsContainer} from "../../shared/AppTabsContainer";
import {
  BaseModuleMain,
  BaseModuleMainProps,
  BaseModuleMainState,
  requiresProject
} from "../../fyneai-shared/BaseModuleMain";
import {DatasetsFragment} from "./datasets/DatasetsFragment";
import {BaseApp} from "../../shared/BaseApp";
import {TeamFragment} from "./team/TeamFragment";

enum Tab {
  DASHBOARD = "dashboard",
  DATASETS = "datasets",
  TEAM = "team",
}

const TABS: Tabs<Tab> = {
  items: [
    {
      type: Tab.DASHBOARD,
      path: "dashboard",
      text: "Dashboard",
      iconType: HomeOutlined,
      render: requiresProject(path => <DashboardFragment path={path}/>),
    },
    {
      type: Tab.DATASETS,
      path: "datasets",
      text: "Datasets",
      iconType: DatasetOutlined,
      nestedPaths: DatasetsFragment.nestedPaths(),
      render: requiresProject(path => <DatasetsFragment path={path}/>),
    },
    {
      type: Tab.TEAM,
      path: "team",
      text: "Team",
      iconType: Groups3Outlined,
      render: requiresProject(path => <TeamFragment path={path}/>),
    },
  ],
  containerId: "main",
}

export type ModuleMainProps = BaseModuleMainProps & {}

type ModuleMainState = BaseModuleMainState & {}

export class ModuleMain extends BaseModuleMain<ModuleMainProps, ModuleMainState> {

  static nestedPaths(prefixPath?: string): PathComponent[] {
    return TabsContainer.nestedPathsFromTabs(TABS, prefixPath);
  }

  protected renderContainerContent(): React.ReactElement | null {
    const tabsColorScheme: TabsColorScheme = BaseApp.CONTEXT.getPreferredColorScheme() || "light";
    return <AppTabsContainer
      path={this.props.path}
      modulePath={this.props.modulePath}
      noLogo={true}
      noUserButton={true}
      tabs={TABS}
      tabsThemeColor={this.theme.palette.grey[tabsColorScheme as string === "light" ? 100 : 900]}
      tabsColorScheme={tabsColorScheme}
    />;
  }
}